
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRouteMonitoringProposal as ObiRouteMonitoringProposalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-route-monitoring-proposal.js';
 
 
 

 
 export const ObiRouteMonitoringProposal = createComponent({
   react: React,
   tagName: 'obi-route-monitoring-proposal',
   elementClass: ObiRouteMonitoringProposalElement,
   events: {
     
   }
  });
 
 